import React, { Fragment, useContext, useEffect, useState } from 'react'
import { WhatsappContext } from './Whatsapp';

function ChatHeaderUser() {
    const { stateWhatsApp, dispatchWhatsApp } = useContext(WhatsappContext);
    const initialState = (
        <div className="col-6">
            <h4></h4>
            <div className="ticket-info"></div>
        </div>
    )
    const [renderUser, setrenderUser] = useState(initialState)
    useEffect(() => {
        if (stateWhatsApp.active != null) {
            const chat = stateWhatsApp.chats.find(chat => chat.id == stateWhatsApp.active)
            setrenderUser(
                <div className="col-6">
                    <h4>{chat.username}</h4>
                    <div className="ticket-info">{chat.phone}</div>
                </div>
            )
        } else {
            setrenderUser(initialState)
        }
    }, [stateWhatsApp.active])

    return (
        <Fragment>
            {renderUser}
        </Fragment>
    )
}

export default ChatHeaderUser
